import { getHttpService } from "../services/http.service";
import { ReCaptchaEndpoint } from "../endpoints/ReCaptchaEndpoint";

const httpService = getHttpService();

export const verifyReCaptcha = (captchaValue: string) => {
  const endpoint = new ReCaptchaEndpoint();
  return httpService.post(endpoint, { token: captchaValue });
};
